// extracted by mini-css-extract-plugin
module.exports = {"root":"RenterResource_root__gVMC7"};